export default function Telegram() {
    return (
        <div id='telegram'>
            <div className='centered-container'>
                <h2> Telegram </h2>
            </div>
        </div>
    );
}